/**
 * Where to go after signing in. Kept in localStorage (not the URL, not
 * sessionStorage) because the sign-in link usually opens in a new tab.
 */
const KEY = 'll.returnTo';
const AUTH_PATHS = ['/sign-in', '/auth/'];

/** Only same-app paths: "/lesson/x" yes; "//evil.example", "https://…", "/sign-in" no. */
export function isSafeReturnPath(path: string): boolean {
  return (
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.startsWith('/\\') &&
    !AUTH_PATHS.some((prefix) => path.startsWith(prefix))
  );
}

export function saveReturnTo(path: string): void {
  if (!isSafeReturnPath(path)) return;
  try {
    localStorage.setItem(KEY, path);
  } catch {
    // Storage unavailable (private mode, blocked): fall back to Today after sign-in.
  }
}

/** Forget any saved path (after a deliberate sign-out, so the next learner starts on Today). */
export function clearReturnTo(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Storage unavailable.
  }
}

/** The saved path (once), or "/" when there is none or it isn't safe. */
export function takeReturnTo(): string {
  let saved: string | null = null;
  try {
    saved = localStorage.getItem(KEY);
    localStorage.removeItem(KEY);
  } catch {
    // Storage unavailable.
  }
  return saved && isSafeReturnPath(saved) ? saved : '/';
}
